import { ReferralEventData } from '../types/';

import eventBg from 'assets/single-event/event_bg.png';

const pastTimestamp = Math.floor(new Date('2025-09-30T00:00:00Z').getTime() / 1000);
const futureTimestamp0 = Math.floor(new Date('2025-11-06T00:00:00Z').getTime() / 1000);
const futureTimestamp1 = Math.floor(new Date('2026-11-30T23:59:59Z').getTime() / 1000);
const futureTimestamp2 = Math.floor(new Date('2026-12-31T23:59:59Z').getTime() / 1000);

export const MOCK_REFERRAL_EVENT_DATA: ReferralEventData = {
  name: 'RMV champion trophy',
  tagline: 'HOLD __$RMV__ - WIN __$1000__ USDT EVERY DAY',
  imageUrl: eventBg,
  bannerUrl: 'https://assets.r5y.io/lgo-live/event/banners/vip_ref.png',
  iconUrl: 'https://assets.r5y.io/lgo-live/event/images/vip_ref.png',
  tiers: [
    { label: 'Tier 5', requiredRewards: 5 },
    { label: 'Tier 4', requiredRewards: 25 },
    { label: 'Tier 3', requiredRewards: 50 },
    { label: 'Tier 2', requiredRewards: 75 },
    { label: 'Tier 2', requiredRewards: 80 },
    { label: 'Tier 2', requiredRewards: 85 },
    { label: 'Tier 1', requiredRewards: 100 },
  ],
  currentRewards: 10,
  nextRewardAt: 25,
  badges: [{ text: '1x Eiffel Tower' }, { text: '2x London Eye' }],
  tableData: {
    rows: [
      {
        rank: '1',
        walletAddress: '0x1234...5678',
        wnftPurchased: '5',
        prize: '1x wNFT for you and referred user',
        isActive: true,
      },
      { rank: '2', walletAddress: '0x8765...4321', wnftPurchased: '3', prize: '$50', isActive: false },
      { rank: '3', walletAddress: '0xabcd...efgh', wnftPurchased: '2', prize: '$25', isActive: false },
      { rank: '4', walletAddress: '0x9876...1234', wnftPurchased: '1', prize: '$10', isActive: false },
    ],
    pagination: {
      currentPage: 1,
      totalPages: 5,
      hasNextPage: true,
      hasPreviousPage: false,
    },
  },
  chartData: [
    { label: '2025-11-10', value1: 10, value2: 10 },
    { label: '2025-11-11', value1: 15, value2: 25 },
    { label: '2025-11-12', value1: 20, value2: 45 },
    { label: '2025-11-13', value1: 12, value2: 57 },
    { label: '2025-11-14', value1: 8, value2: 65 },
    { label: '2025-11-15', value1: 18, value2: 83 },
    { label: '2025-11-16', value1: 14, value2: 97 },
    { label: '2025-11-17', value1: 22, value2: 119 },
    { label: '2025-11-18', value1: 11, value2: 130 },
    { label: '2025-11-19', value1: 16, value2: 146 },
  ],
  analyticsEvents: [
    {
      id: 1,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 2,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 3,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 4,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 5,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 6,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 7,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
    {
      id: 8,
      name: 'Halloween Event',
      imageUrl: eventBg,
      isVip: true,
      isUpcoming: true,
      eventType: 'referral',
    },
  ],
  participationCriteria: [
    {
      title: 'Event Timeline',
      description: '2025/07/09 23:00 - 2025/07/30 23:00 (UTC+8)',
    },
    {
      title: 'Eligibility',
      description:
        'Users with total futures account equity 1 USDT at the time of registration will be eligible for the competition. The platform will review the eligibility of registered users before the commencement of competition. Those who are considered ineligible may register again after transferring sufficient assets to their futures accounts.',
    },
    {
      title: 'Eligible Trading Pairs',
      description: 'All perpetual futures available on the Realitymeta platform (excluding futures like USDC/USDT).',
    },
  ],
  circularProgressOverlay: {
    title: 'Tier 4 NFT',
    nextRewardName: '1x Eiffel Tower',
  },
  nextMilestoneName: 'VIP elite Lv.2',
  quickSummaryStats: {
    ctaLabel: 'Connect wallet',
    items: [
      { title: 'Total Eligable', value: '100' },
      { title: 'Total Purchases', value: '100' },
      { title: 'Total RMV Spent', value: '100' },
      { title: 'Total Purchases', value: '100' },
      { title: 'Total RMV Spent', value: '100' },
    ],
  },
  endAt: futureTimestamp2,
  stages: [
    {
      id: 1,
      name: 'REGISTRATION STARTS',
      timestamp: pastTimestamp,
    },
    {
      id: 2,
      name: 'COMPETITION STARTS',
      timestamp: futureTimestamp0,
    },
    {
      id: 3,
      name: 'REGISTRATION ENDS',
      timestamp: futureTimestamp1,
    },
    {
      id: 4,
      name: 'COMPETITION ENDS',
      timestamp: futureTimestamp2,
    },
    {
      id: 5,
      name: 'REWARDS DISTRIBUTION',
      timestamp: futureTimestamp2,
      description: 'Every week and month',
    },
  ],
  status: 1,
  isParticipating: false,
  eventType: 'referral',
};
